RshopApp.$mount(".l-base");

let resizeTimer = null,
    modalBodyPadding = null,
    lightGallerySettings = {
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false
    };

// ! skopiruj aj c-var z layouts/default.php
function checkResolution(query) {
    let active = false;

    if (!query) {
        return true;
    }

    for (let value of query.split(";")) {
        if ($(".c-var ." + value + "-is-visible").is(":visible")) {
            active = true;
        }
    }

    return active;
}

// function freezeScroll() {
//     const elementsToScroll = $(".js-allow-scroll, .modal");

//     setTimeout(() => {
//         elementsToScroll.each(function() {
//             const $elem = $(this);

//             bodyScrollLock.disableBodyScroll($elem[0]);
//         });
//     }, 1);
// }

// function unfreezeScroll() {
//     bodyScrollLock.clearAllBodyScrollLocks();
// }

const checkIphone = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

const isIphone = checkIphone()
const scrollbarWidth = getScrollbarWidth()
let windowScrollPosition = 0
let isScrollDisabled = false

function freezeScroll() {
    if (!isScrollDisabled) {
        windowScrollPosition = window.pageYOffset
    }

    isScrollDisabled = true

    requestAnimationFrame(() => {
        document.body.classList.add('is-overlayed')

        if (document.body.scrollHeight > window.innerHeight) {
            document.body.style.paddingRight = `${scrollbarWidth}px`
        }

        if (isIphone) {
            document.body.style.position = 'fixed';
            document.body.style.top = `-${windowScrollPosition}px`;
            document.body.style.width = '100%';
        }
    })
}

function unfreezeScroll() {
    isScrollDisabled = false

    if (isIphone) {
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');
    }

    document.body.style.removeProperty('padding-right');
    document.body.classList.remove('is-overlayed')

    requestAnimationFrame(() => {
        if (isScrollDisabled) return

        window.scroll({
            top: windowScrollPosition,
            behavior: 'instant'
        })
    })
}

function toggleElem(object) {
    if (object.active) {
        hideElem(object);
    } else {
        showElem(object);
    }
}

function showElem(object) {
    if (activeElement && activeElement.active) {
        hideElem(activeElement);
    }

    object.trigger.addClass('is-active');
    object.elem.addClass('is-active');

    if (object.overlay) {
        showOverlay(250, object.allowScroll);
    }

    if (object.callback && object.callback.show) {
        object.callback.show();
    }

    object.active = true;

    activeElement = object;
}

function hideElem(object) {
    object.trigger.removeClass('is-active');
    object.elem.removeClass('is-active');

    if (object.overlay) {
        hideOverlay();
    }

    if (object.callback && object.callback.hide) {
        object.callback.hide();
    }

    object.active = false;
}

function showPreloader() {
    $(".preloader").fadeIn(150);
}

function hidePreloader() {
    $(".preloader").fadeOut(150);
}

function calculateSpecialListHeight(settings) {
    const $box = $(settings.selector);

    if ($box.length) {
        const $list = $box.find('.js-categories-list');

        if (settings.clearValues) {
            $list.removeAttr('data-height')
            $list.height('');
        }

        if (settings.disabled && checkResolution(settings.disabled)) {
            $list.height('');

            return false;
        }

        let listHeight = $list.attr('data-height');

        if (!parseInt(listHeight)) {
            const $items = $list.find('.js-category-item:not(.is-hidden):not(.is-more)');

            let firstColItems = Math.ceil($items.length / 2);

            if ($items.length > 4) {
                firstColItems = Math.floor(($items.length + 3) / 2);
            }
            else if ($items.length == 4) {
                firstColItems += 1;
            }

            let colHeight = {
                first: 0,
                second: 0
            };

            $.each($items, function(index, v) {
                if (index < firstColItems) {
                    colHeight.first += $(this).outerHeight()
                }
                else {
                    colHeight.second += $(this).outerHeight()
                }
            });

            // TODO: nth pridat do prveho stlpca vysku dalsieho elementu
            listHeight = colHeight.second > colHeight.first ? colHeight.second : colHeight.first;
        }

        $list
            .attr('data-height', listHeight)
            .height(listHeight);
    }
}


function animateProductSlides(slider) {
    const $dots = slider.elem.find('.js-products-slider-dots'),
        $nav = slider.elem.find('.js-products-slider-nav'),
        $wrapper = slider.elem.find('.swiper-wrapper');

    if (checkResolution('cxs;xs2') || slider.elem.find('.swiper-slide.is-active.swiper-slide-active').length) {
        $dots.removeClass('is-sliding');
        $nav.removeClass('is-sliding');

        return false;
    }

    const $currentSlides = slider.elem.find('.swiper-slide.is-active'),
        slidesPerView = checkResolution('xs;sm') ? 5 : 6,
        nextActiveSlideIndex = slider.elem.find('.swiper-slide.swiper-slide-active').index(),
        $nextSlides = slider.elem.find('.swiper-slide').slice(nextActiveSlideIndex, nextActiveSlideIndex + slidesPerView);

    $dots.addClass('is-sliding');
    $nav.addClass('is-sliding');

    const $slides = $.merge($currentSlides, $nextSlides);

    $slides.last().one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
        slider.elem.find('.swiper-slide').removeClass('is-animating');
        $wrapper.removeClass('is-animating');
        repositionProductSlides(slider);

        setTimeout(() => {
            $dots.removeClass('is-sliding');
            $nav.removeClass('is-sliding');
        }, 10);
    });

    $wrapper.addClass('is-animating');
    $slides.each(function() {
        $(this).addClass('is-animating');
    });
}

function repositionProductSlides(slider) {
    if (checkResolution('cxs;xs2')) {
        return false;
    }

    const slidesPerView = checkResolution('xs;sm') ? 5 : 6;

    let activePage = false,
        itemNumber = 0,
        overflowingSlides = slider.elem.find('.swiper-slide:not(.is-blank)').length % slidesPerView;

    if (overflowingSlides > 0) {
        let $blankSlides = slider.elem.find('.swiper-slide.is-blank'),
            blanksToFill = slidesPerView - overflowingSlides;

        if ($blankSlides.length !== blanksToFill) {
            const $swiperWrapper = slider.elem.find('.swiper-wrapper');
            $blankSlides.remove();

            for (let i = 0; i < blanksToFill; i++) {
                $swiperWrapper.append('<div class="swiper-slide is-blank"></div>');
            }
        }
    } else {
        slider.elem.find('.swiper-slide.is-blank').remove();
    }

    slider.slider.update();

    slider.elem.find('.swiper-slide').each(function() {
        const $slide = $(this);

        $slide.removeClass(function (index, className) {
            return (className.match (/(is-active)|(is-\d)/g) || []).join(' ');
        });

        if (++itemNumber % (slidesPerView + 1) == 0) {
            itemNumber = 1;
            activePage = false;
        }

        if ($slide.hasClass('swiper-slide-active')) {
            activePage = true;
        }

        if (activePage) {
            $slide.addClass('is-active');
        }

        $slide.addClass('is-' + itemNumber);
    });
}

function createStars($elem, options) {
    if ($elem.hasClass('.is-initialized')) {
        return false;
    }

    $elem.starRating($.extend({}, {
        starSize: 16,
        initialRating: $elem.attr('data-stars') * 5 / 100,
        readOnly: false,
        starShape: 'rounded',
        emptyColor: '#E0EBF5',
        activeColor: '#F8C81C',
        hoverColor: '#F8C81C',
        ratedColor: '#F8C81C',
        useGradient: false,
        strokeWidth: 0,
        disableAfterRate: false
    }, options));

    $elem.addClass('is-initialized');
}

function checkNotificationType(elem) {
    var $price_input = $('.watchdog_price'),
        isCheaper = $(elem).val() == "become_cheaper";

    if (isCheaper) {
        $price_input.slideDown();
    } else {
        $price_input.slideUp();
    }
}

function watchdogModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-form-modal-watchdog').validate({
        rules: {
            custom_customer_phone: {
                phone: true
            },
            notification_price: {
                number: true
            }
        },
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-watchdog-error').slideUp(100);
            $('.js-watchdog-success').slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function (data) {
                    $modal.find('[type="submit"]').prop('disabled', false);

                    if (!data.status) {
                        $('.js-watchdog-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-watchdog-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-watchdog-hide').slideUp(200);
                    }
                }, 'json');
            });
        }
    });

    checkNotificationType($('#notification_type'));

    $('#notification_type').on('change', function () {
        checkNotificationType($(this));
    });
}

function wishlistModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function (data) {
                    $modal.find('[type="submit"]').prop('disabled', false);

                    if (!data.status) {
                        $('.js-wishlist-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-wishlist-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-wishlist-hide').slideUp(200);
                    }
                }, 'json');
            });
        }
    });

    $('.js-new-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function (data) {
                    $modal.find('[type="submit"]').prop('disabled', false);

                    if (!data.status) {
                        $('.js-wishlist-error')
                            .text(data.message)
                            .slideDown(200);
                    } else {
                        $('.js-wishlist-success')
                            .text(data.message)
                            .slideDown(200);
                        $('.js-wishlist-hide').slideUp(200);
                    }
                }, 'json');
            });
        }
    });
}

function updateCompanyVatPayer() {
    const skCountryId = '1';
    const $notVatPayer = $('.js-not-vat-payer');
    $notVatPayer.closest('.c-form__item').removeClass('hidden');

    $('.js-country-select').each(function() {
        if ($(this).val() == skCountryId && ($(this).hasClass('is-billing') || $(this).hasClass('is-shipping') && !$('input[name="shipping_same_as_billing"]').is(':checked'))) {
            $notVatPayer.prop('checked', true);
            $notVatPayer.closest('.c-form__item').addClass('hidden');
        }
    });

    $notVatPayer.trigger('change');
}

$('body').on('shown.bs.modal', '#up-sell', function (e) {
    const swiperInstance = $('.js-promotion-products-upsell')[0].swiper;

    if (swiperInstance) {
        swiperInstance.slideTo(0, 0);
        swiperInstance.update();
    }

    $('.js-stars').each(function() {
        createStars($(this), {
            readOnly: true,
            starSize: parseInt($(this).attr('data-size')) || 16
        });
    });

    setTimeout(function() {
        if (swiperInstance) {
            swiperInstance.slideTo(0, 0);
            swiperInstance.update();
        }
    }, 100);
});

rEvent.on('Cart.upsell.show', function() {
    setTimeout(() => {
        initializePromotionScroll()
    }, 200)

    if ($('.js-promotion-products-upsell').length) {
        const upsellSwiper = {
            promotionProducts: {
                slider: false,
                elem: $('.js-promotion-products-upsell'),
                active: false,
                query: false,
                tooltipOpen: false,
                options: {
                    loop: false,
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 10,
                    simulateTouch: false,
                    roundLengths: true,
                    navigation: {
                        nextEl: '.js-promotion-products-upsell-next',
                        prevEl: '.js-promotion-products-upsell-prev',
                        disabledClass: 'is-disabled',
                        hiddenClass: 'is-hidden'
                    },
                    breakpoints: {
                        1199: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                        1023: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                        767: {
                            slidesPerView: 'auto',
                            slidesPerGroup: 1,
                            slidesOffsetBefore: 12,
                            slidesOffsetAfter: 12,
                            freeMode: true
                        },
                        599: {
                            slidesPerView: 'auto',
                            slidesPerGroup: 1,
                            slidesOffsetBefore: 12,
                            slidesOffsetAfter: 12,
                            freeMode: true
                        },
                        359: {
                            slidesPerView: 'auto',
                            slidesPerGroup: 1,
                            slidesOffsetBefore: 12,
                            slidesOffsetAfter: 12,
                            freeMode: true
                        },
                    },
                    on: {
                        init: function () {
                            const swiperInstance = $('.js-promotion-products-upsell')[0].swiper;
                            swiperInstance.slideTo(0, 0);
                            swiperInstance.update();
                        },
                        slideChange: function () {
                            setTimeout(() => {
                                animateProductSlides(globalSwipers.products);
                                bLazy.revalidate();
                            }, 500);
                        },
                    }
                }
            }
        };

        checkSliders(upsellSwiper);
    }
});

function adjustMaxHeightElements() {
    $(".js-max-height").each(function() {
        const $el = $(this),
            $holder = $(this).find('.is-holder'),
            $moreButton = $(this).find('.js-max-height-trigger'),
            lineHeight = parseFloat($holder.css('line-height')),
            maxLines = $el.data('max-lines'),
            moreText = $moreButton.data("more-text"),
            lessText = $moreButton.data("less-text"),
            isOpen = $el.hasClass('is-open'),
            hasMoreContent = maxLines * lineHeight < $holder[0].scrollHeight;

        $moreButton.toggle(hasMoreContent);
        $el.toggleClass('has-gradient', hasMoreContent);

        if (hasMoreContent) {
            $moreButton.html(isOpen ? lessText : moreText);
        }
    });
}

rEvent.on('Window.resized', function() {
    adjustMaxHeightElements();
});

function checkPostCodeType(firstTime = false) {
    $('[name*="country_id"]').each(function(){
        const $select = $(this).closest('.l-row').find('.js-post-code-select');

        if ($(this).val() == 190 || $(this).val() == 232) {
            $select.removeClass('hidden');

            // if (firstTime && $hidden.val() != '') {
            //     $select.find('[name="post_code_select"]').val($hidden.val());
            // } else {
            //     setPostCodeValue($select.find('[name="post_code_select"]'));
            // }
        } else {
            $select.addClass('hidden');

            // if (firstTime && $hidden.val() != '') {
            //     $input.find('[name="post_code_input"]').val($hidden.val());
            // } else {
            //     setPostCodeValue($input.find('[name="post_code_input"]'));
            // }
        }

    });
}

function setPostCodeValue($fakeInput) {
    const newValue = $fakeInput.val();

    $fakeInput.closest('.l-col').find('.js-post-code-hidden').val(newValue);
}

function updateScrollIndicators(holder, content) {
    let isScrollableUp = false
    let isScrollableDown = false

    if (content.scrollHeight > holder.offsetHeight) {
        isScrollableUp = content.scrollTop > 0
        isScrollableDown = content.scrollTop < content.scrollHeight - content.offsetHeight
    }

    holder.classList.toggle('is-scrollable-up', isScrollableUp);
    holder.classList.toggle('is-scrollable-down', isScrollableDown);
}

function initializePromotionScroll() {
    for (const promotionProductsScrollHolder of document.querySelectorAll('.js-promotion-products-scroll-holder')) {
        if (promotionProductsScrollHolder.classList.contains('is-initialized')) {
            continue
        }

        const promotionProductsScrollContent = promotionProductsScrollHolder.querySelector('.js-promotion-products-scroll-content')

        updateScrollIndicators(promotionProductsScrollHolder, promotionProductsScrollContent)

        promotionProductsScrollContent.addEventListener('scroll', () => {
            updateScrollIndicators(promotionProductsScrollHolder, promotionProductsScrollContent)
            bLazy.revalidate()
        });

        rEvent.on('Window.resized', () => {
            updateScrollIndicators(promotionProductsScrollHolder, promotionProductsScrollContent)
        });

        promotionProductsScrollHolder.classList.add('is-initialized')
    }
}

$(function() {
    initializePromotionScroll()

    setTimeout(function() {
        bLazy.revalidate();
    }, 1000);

    setTimeout(function() {
        bLazy.revalidate();
    }, 5000);

    setTimeout(function() {
        bLazy.revalidate();
    }, 10000);

    setTimeout(function() {
        bLazy.revalidate();
    }, 20000);

    tippy('.js-tippy-white', {
        arrow: true,
        theme: 'white',
        performance: true,
        interactive: true,
        maxWidth: '600px'
    });

    $('.js-anchor').on('click', function (event) {
        event.preventDefault();

        let href = $(this).attr('href');

        if (!href) {
            href = $(this).data('href');
        }

        if (!href) {
            return false;
        }

        if ($(this).data('tab')) {
            $('a[role="tab"][href="' + $(this).data('tab') + '"]:not(.is-active):visible').click();

            if (checkResolution('cxs;xs')) {
                setTimeout(function() {
                    slideTo($(href), 25, 300);
                }, 500);
            } else {
                slideTo($(href), 25, 300);
            }
        } else {
            slideTo($(href), 25, 300);
        }

    });

    $(document).on('show.bs.modal', '.modal', function () {
        freezeScroll();

        setTimeout(function () {
            bLazy.revalidate();
        }, 1000);
    });

    $(document).on('hide.bs.modal', '.modal', function () {
        modalBodyPadding = parseInt($('body').css('padding-right'));
    });

    $(document).on('hidden.bs.modal', '.modal', function () {
        if (modalBodyPadding > 0) {
            $('body').css('padding-right', modalBodyPadding);
            modalBodyPadding = 0;
        }

        unfreezeScroll();

        setTimeout(() => {
            $('body').css('padding-right', '');
        }, 1);
    });

    // shorten
    $(".js-shorten").each(function() {
        const $elem = $(this),
            count = $elem.data("count"),
            more = $elem.data("more-text"),
            less = $elem.data("less-text");

        $elem.shorten({
            showChars: count,
            ellipsesText: "...",
            moreText: more,
            lessText: less
        });
    });

    $('.js-stars').each(function() {
        createStars($(this), {
            readOnly: true,
            starSize: parseInt($(this).attr('data-size')) || 16
        });
    });

    $("body").on("click", ".pager__item:not(.is-disabled) a", function() {
        $(this)
            .parents(".listing")
            .slideHere(0);

        if ($('.listing__holder').length) {
            $('.listing__holder').addClass('is-loading');
        }
    });

    $('.js-not-vat-payer').on('change', function() {
        const isChecked = $(this).is(':checked'),
            $vatNumInput = $('.js-vat-num-input');

        $vatNumInput.prop('required', !isChecked);
        $vatNumInput.parents('.c-form__item').first().toggleClass('is-required', !isChecked);
    });

    if (Eshop.options.locale != 'sk_SK' && $('.js-not-vat-payer').length) {
        updateCompanyVatPayer();

        $('input[name="shipping_same_as_billing"]').on('change', function() {
            updateCompanyVatPayer();
        });

        $('.js-country-select').on('change', function() {
            updateCompanyVatPayer();
        });
    }

    $(window).on('resize', function (e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            rEvent.dispatch('Window.resized');
        }, 250);
    });

    adjustMaxHeightElements();

    $('.js-max-height-trigger').on('click', function(e) {
        e.preventDefault();

        const $moreButton = $(this),
            $maxHeightEl = $(this).parents('.js-max-height'),
            moreText = $moreButton.data("more-text"),
            lessText = $moreButton.data("less-text");

        $maxHeightEl.toggleClass('is-open');

        $moreButton.html($maxHeightEl.hasClass('is-open') ? lessText : moreText);
    });

    checkPostCodeType(true);

    $('[name*="country_id"]').on('change', function() {
        checkPostCodeType();
    });

    // $('[name="post_code_select"], [name="post_code_input"]').on('change', function() {
    //     setPostCodeValue($(this));
    // });

    $(document).on('submit', '.js-form-country-change', function(event) {
        event.preventDefault(); // Prevent default form submission

        let form = $(this);
        form.addClass('is-loading');

        Form.ajaxPost(form, function (data) {
            Eshop.alert(data.msg, {
                'type': data.status ? 'success' : 'error'
            });

            if (data.status) {
                setCookie("location-modal-shown", true, 3650);
                window.location.reload();
            } else {
                form.removeClass('is-loading');
            }
        }, 'json');
    });

    $('.js-change-country-select').not('.is-loaded, .selectpicker').each(function () {
        let $select = $(this),
            classes = '';

        if ($select.hasAttr('data-class')) {
            classes = ' ' + $select.data('class');
        }

        /*if (/country_id/i.test($select.attr('name'))) {
            options.maxHeight = 185;
        }*/

        $select.multiselect({
            enableHTML: true,
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-caret-down"></i></button>'
            },
            buttonClass: 'c-btn has-icon' + classes,
            nonSelectedText: 'ttotok',
        });

        $select.addClass('is-loaded');
    });
});
